import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserProfile } from '../services/api';
import { FaUser, FaEnvelope, FaIdBadge, FaSpinner } from 'react-icons/fa';

const UserProfile = ({ token, handleLogout }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await getUserProfile(token);
        if (response.cod === 200) {
          setUser(response.data);
        } else {
          setError('Sesión expirada. Por favor, inicia sesión de nuevo.');
          handleLogout();
          navigate('/login');
        }
      } catch (err) {
        setError('Error de conexión. Inténtalo de nuevo más tarde.');
        navigate('/login');
      }
    };
    fetchUserProfile();
  }, [token, handleLogout, navigate]);

  if (error) {
    return <div className="flex items-center gap-3 px-4 py-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">{error}</div>;
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center h-64">
        <FaSpinner className="w-6 h-6 animate-spin text-emerald-600" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Mi Perfil</h1>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden max-w-lg">
        <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 p-6 text-white">
          <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center text-white text-2xl font-bold mb-3">
            {user.nombre_usuario?.charAt(0).toUpperCase() || 'U'}
          </div>
          <h2 className="text-xl font-bold">{user.nombre_usuario}</h2>
          <p className="text-sm text-emerald-100">{user.email}</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-4 py-3 border-b border-gray-100">
            <FaUser className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-xs text-gray-500 font-medium">Usuario</p>
              <p className="text-sm text-gray-800">{user.nombre_usuario}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 py-3 border-b border-gray-100">
            <FaEnvelope className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-xs text-gray-500 font-medium">Email</p>
              <p className="text-sm text-gray-800">{user.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 py-3">
            <FaIdBadge className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-xs text-gray-500 font-medium">Rol</p>
              <p className="text-sm text-gray-800">{user.id_rol === 1 ? 'Administrador' : 'Usuario'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;